import {
  appendHoldingLevelCostColumnsWithDpName,
  orderTransactionCostBenchmarkAndMemberColumns,
} from "../../../utils/reports/transactionMetadataColumns";
import {
  FieldColumn,
  INSURANCE_BASE_COLUMNS,
  INSURANCE_OPTIONAL_COLUMN_KEYS,
  INSURANCE_SUMMARY_REPORT,
  INVESTOR_COLUMN,
  isInsuranceSummaryReport,
} from "./insuranceReportConfig";

export const REPORT_BUILDER_VISIBLE_COLUMN_COUNT = 7;

const stripMemberNameColumn = (cols: FieldColumn[]): FieldColumn[] =>
  orderTransactionCostBenchmarkAndMemberColumns(cols, {
    includeMemberName: false,
  }) as FieldColumn[];

const buildInsuranceSummaryColumns = (): FieldColumn[] =>
  stripMemberNameColumn(
    appendHoldingLevelCostColumnsWithDpName(INSURANCE_BASE_COLUMNS),
  );

const buildInsuranceDueDateColumns = (): FieldColumn[] =>
  stripMemberNameColumn([...INSURANCE_BASE_COLUMNS]);

export const getBaseColumnsForReportType = (reportType: string): FieldColumn[] => {
  if (isInsuranceSummaryReport(reportType)) {
    return buildInsuranceSummaryColumns();
  }
  return buildInsuranceDueDateColumns();
};

export const buildSelectableColumns = (reportType: string): FieldColumn[] => [
  INVESTOR_COLUMN,
  ...getBaseColumnsForReportType(reportType),
];

export const buildEffectiveColumns = (
  reportType: string,
  visibleColumnKeys: string[],
): FieldColumn[] => {
  let columns = buildSelectableColumns(reportType);
  if (visibleColumnKeys.length > 0) {
    const visible = new Set(visibleColumnKeys);
    columns = columns.filter((c) => visible.has(c.key));
  }
  return columns;
};

/** Default visible columns exclude optional keys (nominee, nextPremiumAmount, purchaseDate). */
export const getDefaultVisibleColumnKeys = (reportType: string): string[] =>
  buildSelectableColumns(reportType)
    .map((c) => c.key)
    .filter((key) => !INSURANCE_OPTIONAL_COLUMN_KEYS.has(key));
